import { render, staticRenderFns } from "./NavComponent.vue?vue&type=template&id=3e8a423c"
import script from "./NavComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./NavComponent.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./NavComponent.vue?vue&type=style&index=0&id=3e8a423c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_prettier@3.6.2_vue-template-compiler@2.7.16_webpack@5.103.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports